import React from 'react';
export const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="w-full py-10 sm:py-12 border-t border-gray-200 bg-[#0a1445]" data-id="element-61">
      <div className="max-w-6xl mx-auto px-4" data-id="element-62">
        <div className="grid grid-cols-2 sm:flex sm:flex-row justify-between items-start gap-8" data-id="element-63">
          <div className="flex flex-col items-start col-span-2 mb-6 sm:mb-0" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/1fyPWMXVhqijtztkRzsHB9/pasted-image.png" alt="HIRE Logo" className="h-10 mb-4" data-id="element-65" />
            <p className="text-white/70 text-sm sm:text-base" data-id="element-66">
              Guaranteed recruiting for door-to-door
              <br data-id="element-67" />
              solar and roofing businesses
            </p>
          </div>
          <div className="flex flex-col items-start" data-id="element-68">
            <h3 className="text-white font-medium mb-3 text-sm sm:text-base" data-id="element-69">
              Navigate
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-70">
              <li data-id="element-71">
                <button onClick={() => scrollToSection('headline')} className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-72">
                  Our Promise
                </button>
              </li>
              <li data-id="element-73">
                <button onClick={() => scrollToSection('stats')} className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-74">
                  Our Results
                </button>
              </li>
              <li data-id="element-75">
                <button onClick={() => scrollToSection('faq')} className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-76">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-start" data-id="element-77">
            <h3 className="text-white font-medium mb-3 text-sm sm:text-base" data-id="element-78">
              Legal
            </h3>
            <ul className="flex flex-col gap-2" data-id="element-79">
              <li data-id="element-80">
                <a href="https://get.thehireadvantage.co/privacypolicy" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-81">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-82">
                <a href="https://get.thehireadvantage.co/terms" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors text-sm sm:text-base" data-id="element-83">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 sm:mt-10 pt-4 sm:pt-6 border-t border-white/10 text-center" data-id="element-84">
          <p className="text-white/50 text-xs sm:text-sm" data-id="element-85">
            © {new Date().getFullYear()} The HIRE Advantage. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};